(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-options"] && !Shopify.designMode) return;
  try {
    (() => {
    function syncStatus(input) {
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      const label = input.labels && Array.from(input.labels).find(item => item.querySelector('[data-bpt-option-status]'));
      const status = label && label.querySelector('[data-bpt-option-status]');
      if (!status) return;
      const unavailable = input.classList.contains('disabled') || input.classList.contains('unavailable') || input.classList.contains('non-existent');
      const text = unavailable ? (window.variantStrings?.unavailable || '') : '';
      if (status.textContent !== text) status.textContent = text;
    }
    function initialize(root) {
      root.querySelectorAll('label [data-bpt-option-status]').forEach(status => {
        const input = document.getElementById(status.closest('label').htmlFor);
        if (!input || input.dataset.bptStatusObserved) return;
        input.dataset.bptStatusObserved = 'true';
        syncStatus(input);
        new MutationObserver(() => syncStatus(input)).observe(input, { attributes: true, attributeFilter: ['class', 'disabled'] });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
